module.exports = __webpack_public_path__ + "static/media/phone-background.539eb8e3.png";